// extracted by mini-css-extract-plugin
module.exports = {"formTable":"FormTable_formTable__3Z_VJ"};